import z from "zod";
import { ShippingAddress, ShippingLevel } from "../lulu/LuluPrintTypes";
import { StripUnderscore, UnderscoreKeys } from "../util/Types";
import { OrderUI, orderUISchema } from "./OrderUI";



export const orderItemDbSchema = orderUISchema.extend({
  _paymentSessionId: z.string()
});

export type OrderDbFields = StripUnderscore<z.infer<typeof orderItemDbSchema>>;

export class OrderDb<TFields extends OrderDbFields = OrderDbFields> extends OrderUI<TFields> {
	private _paymentSessionId!: string;
	override _className: string = "Order";
	override _deserializeClassName: string = "OrderDb";

	constructor(props : Partial<TFields>) {
		super(props);
	}
	override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
		return [...super.getFieldList(), "_paymentSessionId"];
	}
	override validateSchema(): void {
		orderItemDbSchema.parse(this);
	}
	get paymentSessionId(): string {
		return this.checkFieldType<"paymentSessionId">(this._paymentSessionId);
	}
	set paymentSessionId(value: string) {
		this._paymentSessionId = this.checkFieldTypeAndMark<"paymentSessionId">("_shippingAddress", value);
	}
}
